import { compose } from 'redux';
import { connect, screenreaderNotification, changeQuizOutcomeAlignmentSetGuid, saveQuizChange, makeEditable, makeScrollable } from '@instructure/quiz-core';
import { OutcomesEditPanel as OutcomesEditPanelPresenter } from './presenter';
function mapStateToProps(state) {
  return {
    appContainer: state.getIn(['ui', 'appContainer'])
  };
}
var mapDispatchToProps = {
  changeQuizOutcomeAlignmentSetGuid: changeQuizOutcomeAlignmentSetGuid,
  saveQuizChange: saveQuizChange,
  screenreaderNotification: screenreaderNotification
};
export var OutcomesEditPanel = compose(connect(mapStateToProps, mapDispatchToProps), makeEditable, makeScrollable)(OutcomesEditPanelPresenter);
export default OutcomesEditPanel;